// Copyright (c) StrangeBee 2023

import { Form } from 'antd';
import React, { ReactElement } from 'react';
import { WidgetLineOutput } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { LineForm, LineValues } from '@Organisms/Dashboard/WidgetManage/Line/LineForm';
import { getNewLineWidget } from './NewLineDrawer';

interface LineManageProps {
    data: WidgetLineOutput;
}

const LineDrawer = ({ data }: LineManageProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (line: LineValues): void => {
        const widgetId = data.id;
        const widgetLine: WidgetLineOutput = {
            ...getNewLineWidget(line),
            id: widgetId,
        };

        editWidget(widgetLine, widgetId);

        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="line">
            {(toggleDrawer, { setFieldsTouched }) => (
                <LineForm
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    onCancel={() => {
                        setFieldsTouched(false);
                        toggleDrawer();
                        form.resetFields();
                    }}
                    onChange={() => setFieldsTouched(true)}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default LineDrawer;
